import { type ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface PageShellProps {
  children: ReactNode;
}

export default function PageShell({ children }: PageShellProps) {
  return (
    <div className="w-full min-h-screen bg-background-50 font-body">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}